<template>
  <div class="progress-bar">
    <q-linear-progress v-bind="progressAttrs" :size :value :color rounded />

    <span v-if="hideLabel === false" class="progress-bar__label">
      {{ computedLabel }}
    </span>
  </div>
</template>

<script setup>
import { computed, useAttrs } from "vue";

const attrs = useAttrs();

// class/style on <c-progress> size the wrapper (width, margins) and already
// land there via attribute fallthrough. Passing them on to the track as well
// made a min-width fill the whole wrapper, pushing the label past its container
// and over the next column.
const progressAttrs = computed(() => {
  const rest = { ...attrs };

  delete rest.class;
  delete rest.style;

  return rest;
});

const props = defineProps({
  size: {
    type: String,
    default: () => "20px",
  },
  value: {
    type: Number,
    default: () => 0,
  },
  color: {
    type: String,
    default: () => "primary",
  },
  label: {
    type: [String, null],
    default: () => null,
  },
  completed: {
    type: Number,
    default: () => 0,
  },
  total: {
    type: Number,
    default: () => 0,
  },
  hideLabel: {
    type: Boolean,
    default: () => false,
  },
});

const computedLabel = computed(() => {
  if (props.label) {
    return props.label;
  }

  return `${props.completed}/${props.total}`;
});
</script>

<style lang="scss">
.progress-bar {
  @apply tw-flex tw-w-full tw-flex-row tw-items-center tw-gap-4;

  .q-linear-progress {
    @apply tw-flex tw-flex-1 tw-items-center tw-justify-center;
  }

  &__label {
  }
}
</style>
